import http from "../plugins/axios"

export const getTestimoniList = async (params) => {
  try {
    const response = await http.get(`/testimonies`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}